import {
  DeleteLeadRequest,
  GetLeadsRequest,
  GetLeadsResponse,
  UpdateLeadNoteRequest,
} from "@/types/leadsTypes";
import {createApi, FetchArgs} from "@reduxjs/toolkit/query/react";
import platformAuthConfig from "./platformConfig";
import listBuildingApi from "./listBuildingApi";

export type TagTypes = "Leads";

const leadsApi = createApi({
  reducerPath: "leadsApi",
  ...platformAuthConfig(),
  tagTypes: ["Leads", "ListItems"],
  endpoints: (builder) => ({
    getLeads: builder.query<GetLeadsResponse, GetLeadsRequest>({
      query: (config): FetchArgs => {
        const params = new URLSearchParams();
        if (config.query) params.set("query", config.query);
        if (config.social_media_type) params.set("social_media_type", config.social_media_type);
        if (config.page) params.set("page", String(config.page));
        if (config.limit) params.set("limit", String(config.limit));
        const queryString = params.toString();
        const path = config.query ? "search" : "";
        return {
          url: `/crm/${config.org_id}/list${path ? `/${path}` : ""}${queryString ? `?${queryString}` : ""}`,
          method: "GET",
        };
      },
      providesTags: ["Leads"],
    }),
    deleteLeads: builder.mutation<void, DeleteLeadRequest>({
      query: (config): FetchArgs => ({
        url: `/crm/${config.org_id}/list/${config.list_id}/item/${config.item_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Leads"],
    }),
    updateLeadNote: builder.mutation<void, UpdateLeadNoteRequest>({
      query: (config): FetchArgs => ({
        url: `/crm/${config.org_id}/list/${config.list_id}/item/${config.item_id}`,
        method: "PUT",
        body: config,
      }),
      invalidatesTags: ["Leads"],
      async onQueryStarted(_, {dispatch, queryFulfilled}) {
        await queryFulfilled;
        dispatch(listBuildingApi.util.invalidateTags(["ListItems"]));
      },
    }),
  }),
});

export const {
  useGetLeadsQuery,
  useDeleteLeadsMutation,
  useUpdateLeadNoteMutation,
} = leadsApi;

export default leadsApi;
